export function formatNumber(number) {
    if (isNaN(number) || number === null || number === '') {
        return ''
    }

    // To avoid weird Javascript logic like 2.6 + 0.2 = 2.8000000000000003
    // we round to 10 decimals, then remove unneeded zeroes
    // and finally replace . with ,
    return number.toFixed(10).replace(/\.?0+$/, '').replace('.', ',')
}
